if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.handleScrollRef = this.handleScroll.bind(this);
      this.handleResizeRef = this.handleResize.bind(this);
      this.headerWrapper = document.querySelector('header-wrapper');
    }

    handleScroll() {
      this.classList.toggle('announcement-bar--scrolled', window.scrollY > this.offset);
    }

    handleResize() {
      document.documentElement.style.setProperty('--header-position-top', this.firstElementChild.scrollHeight + 'px');
    }

    handleHoverState() {
      this.classList.toggle('announcement-bar--hover', this.matches(':hover'));

      this.headerWrapper?.classList.toggle('header-wrapper--hover', this.matches(':hover'));
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResizeRef, false);
    }

    connectedCallback() {
      this.handleResize();

      if (this.hasAttribute('data-is-transparent')) document.querySelector('main').classList.add('no-padding');

      document.body.classList.add('has-announcement-bar');

      this.firstSection = document.querySelector('main .shopify-section:first-of-type');
      this.offset = this.firstSection ? this.firstSection.clientHeight : 0;
      document.addEventListener('scroll', this.handleScrollRef, false);

      window.addEventListener('resize', this.handleResizeRef, false);
      this.addEventListener('mouseenter', this.handleHoverState.bind(this));
      this.addEventListener('mouseleave', this.handleHoverState.bind(this));
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
